var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15ZM14.2105 24.2023V15.1727L6.31579 10.6086V18.528C6.31579 18.8898 6.4023 19.2188 6.57533 19.5148C6.74836 19.8109 6.99079 20.0493 7.30263 20.2303L14.2105 24.2023ZM23.0921 20.2303L16.1842 24.2023V15.1727L24.079 10.6086V18.528C24.0796 18.8898 23.9934 19.2188 23.8204 19.5148C23.6474 19.8109 23.4046 20.0493 23.0921 20.2303ZM15.1974 13.4704L18.1332 11.7928L10.3125 7.25329L7.35197 8.95559L15.1974 13.4704ZM23.0181 8.93092L20.1069 10.6332L12.2615 6.11842L14.2105 5.00822C14.523 4.8273 14.852 4.73684 15.1974 4.73684C15.5428 4.73684 15.8717 4.8273 16.1842 5.00822L23.0181 8.93092Z",
    fill: "#102B41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/current_location.29180760fb2452e43728f9b6afe6a5e9.svg";
export { ForwardRef as ReactComponent };